import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit'
import { TMissionOrBadge } from '@smartico/public-api/dist/WSAPI/WSAPITypes'
import { Smartico } from '../../core/Smartico'

interface BadgesState {
    badges: TMissionOrBadge[] | null
    error: string | null
}

const initialState: BadgesState = {
    badges: null,
    error: null,
}

export const fetchBadges = createAsyncThunk('badges/fetchBadges', async (_, { rejectWithValue }) => {
    try {
        const smarticoApi = await Smartico.apiReady
        const response = await smarticoApi.getBadges()
        return response
    } catch (error) {
        return rejectWithValue('Failed to fetch badges')
    }
})

const badgesSlice = createSlice({
    name: 'badges',
    initialState,
    reducers: {
        setBadges(state, action: PayloadAction<TMissionOrBadge[]>) {
            state.badges = action.payload
        },
        updateBadges(state, action: PayloadAction<TMissionOrBadge[]>) {
            state.badges = action.payload
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchBadges.pending, (state) => {
                state.badges = null
                state.error = null
            })
            .addCase(fetchBadges.fulfilled, (state, action) => {
                state.badges = action.payload
                state.error = null
            })
            .addCase(fetchBadges.rejected, (state, action) => {
                state.badges = null
                state.error = action.payload as string
            })
    },
})

export const { setBadges, updateBadges } = badgesSlice.actions

export default badgesSlice.reducer